import React from "react";
import DataGrid from './data-grid';
export default class LocationsGrid extends React.Component {
  render() {
    var data = this.props.data;
    var columns = [{
      field: 'name',
      title: 'Name',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis capitalize"
        }, row.name));
      }
    }, {
      field: 'streetAddress',
      title: 'Address',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis capitalize"
        }, row.streetAddress));
      }
    }, {
      field: 'city',
      title: 'City',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis capitalize"
        }, row.city));
      }
    }, {
      field: 'region',
      title: 'Region',
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
          className: "grid-ellipsis uppercase"
        }, row.region));
      }
    }, {
      field: 'postalCode',
      title: 'Postal Code',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, row.postalCode);
      }
    }, {
      field: 'referenceId',
      title: 'Ref Id',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        return /*#__PURE__*/React.createElement("td", null, row.referenceId || '—');
      }
    }, {
      // Surface the geo data the upload already accepts — the
      // Territory dealer/store maps depend on these coordinates.
      field: 'lat',
      title: 'Coordinates',
      sortable: false,
      cell: props => {
        var row = props.dataItem;
        if (!row.lat || !row.lng) return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
          title: "No coordinates \u2014 geocode via Upload Markets"
        }, "\u2014"));
        return /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
          title: `${row.lat}, ${row.lng}`,
          className: "material-icons",
          style: {
            fontSize: '16px',
            color: '#78d237'
          }
        }, "check_circle"));
      }
    }];

    // Row actions — opt-in via handlers (Manage Data passes them; any
    // other consumer renders the plain grid unchanged).
    if (this.props.onEdit || this.props.onDelete) {
      columns.push({
        field: '_actions',
        title: ' ',
        sortable: false,
        width: '110px',
        cell: props => {
          var row = props.dataItem;
          // Match the Name link + other cells (inherit font size);
          // Delete uses the theme danger token (on-palette destructive).
          return /*#__PURE__*/React.createElement("td", {
            style: {
              whiteSpace: 'nowrap',
              textAlign: 'right'
            }
          }, this.props.onEdit && /*#__PURE__*/React.createElement("a", {
            style: {
              cursor: 'pointer',
              marginRight: '12px'
            },
            onClick: () => this.props.onEdit(row)
          }, "Edit"), this.props.onDelete && /*#__PURE__*/React.createElement("a", {
            style: {
              cursor: 'pointer',
              color: 'var(--plk-danger)'
            },
            onClick: () => this.props.onDelete(row)
          }, "Delete"));
        }
      });
    }
    return /*#__PURE__*/React.createElement(DataGrid, {
      data: data,
      columns: columns,
      pageSize: 10,
      pagination: this.props.pagination,
      onPageRequest: this.props.onPageRequest
    });
  }
}